<template>
  <v-container fluid class="pa-0 ma-0">
    <v-card
      tile
      flat
    >
      <v-btn>성공</v-btn>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'CardSuccess',

  data: () => ({
  }),

  mounted () {
    // window.close() // 이건 되네 ㅎ
    // window.opener.cardPayWinPopRef.close() // 이것도 된다
    // 어쩔 수 없이 전역인 window 변수를 만들어서 작업한다.

    // * 부모창의 함수를 실행한 후 현재 팝업은 닫는다..
    window.opener.cardPayWindowRefunc('success')
    // window.opener.cardPayWinPopRef.close()
    //
  },

  methods: {
  }
}
</script>
